<template>
	<section class="pass-series">
    <div class="pass-series--wrapper">
      <div class="pass-series--container">
        <p class="pass-series--title">
          Conheça as séries essenciais que o benefício contempla:
        </p>
        <v-carousel>
          <template v-for="(item, index) in slider">
            <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index">
              <v-row class="flex-nowrap ma-0 serie-container" style="height:100%">
                <template v-for="(n,i) in columns">
                  <template v-if="(+index + i) < slider.length">
                    <v-col :key="i" align="center" justify="center" class="pa-0 serie-col">
                      <v-sheet class="serie-content" v-if="(+index + i) < slider.length">
                        <v-row class="fill-height ma-0" align="center" justify="center" height="431">
                          <img class="serie-image" :src="slider[+index + i].image"/>
                          <div class="serie-text">
                            <div class="serie-titles">
                              <p class="serie-title">{{slider[+index + i].title}}</p>
                              <p class="serie-author">{{slider[+index + i].author}}</p>
                            </div>
                            <p class="serie-description ma-0">{{slider[+index + i].description}}</p>
                          </div>
                        </v-row>
                      </v-sheet>
                    </v-col>
                  </template>
                </template>
              </v-row>
            </v-carousel-item>
          </template>
        </v-carousel>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data(){
		return {
      slider: [
        {
          image: '/static/assinaturas/empiricus-crypto-legacy-min.jpg',
          title: 'Empiricus Crypto Legacy',
          author: 'Por Vinicius Bazan',
          description: 'A série traz uma visão macro do mercado de criptoativos, que cresceu exponencialmente a partir do surgimento do Bitcoin, e indica as principais oportunidades de ganho nesse ambiente permeado...',
        },
        {
          image: '/static/assinaturas/palavra-do-estrategista-min.jpg',
          title: 'Palavra do Estrategista',
          author: 'Por Felipe Miranda',
          description: 'Além de pensar no que é mais lucrativo, o estrategista-chefe da Empiricus, Felipe Miranda, não se limita a levantar problemas e analisar cenários conturbados. Mas, sim, compartilha experiências e oferece soluç...',
        },
        {
          image: '/static/assinaturas/as-melhores-acoes-da-bolsa-min.jpg',
          title: 'As melhores Ações da Bolsa',
          author: 'Por Fernando Ferrer',
          description: 'Uma equipe completa de editores vasculha os mais de 300 papéis listados na Bolsa procurando as oportunidades mais lucrativas e com o maior potencial de valorização a longo prazo.',
        },
        {
          image: '/static/assinaturas/double-income-min.jpg',
          title: 'Double Income',
          author: 'Por Felipe Miranda',
          description: 'Ativos com capacidade para dobrar seus ganhos mensais com uma distribuição balanceada entre títulos de renda fixa, ações boas pagadoras de dividendos e fundos imobiliários que geram renda.',
        },
        {
          image: '/static/assinaturas/renda-imobiliaria-min.jpg',
          title: 'Renda Imobiliária',
          author: 'Por Caio Araujo',
          description: 'Conheça as melhores alternativas de renda imobiliária focada em ganho de capital e geração de renda com menor risco e maior liquidez. Uma forma simples e prática de investir no mercado imobiliário.',
        },
        {
          image: '/static/assinaturas/os-melhores-fundos-de-investimento-min.jpg',
          title: 'Os melhores fundos de investimento',
          author: 'Por Bruno Mérola',
          description: 'Entenda como funciona o mercado e tenha as melhores sugestões de investimento sobre os mais variados tipos de fundos. A melhor seleção de fundos de investimento, desde a renda fixa até a variável.',
        },
        {
          image: '/static/assinaturas/investidor-internacional-min.jpg',
          title: 'O Investidor Internacional',
          author: 'Por João Piccioni',
          description: 'Essa é nossa série Essencial para quem quer diversificar uma parte do portfólio no mercado externo, e, além de ganhar com a valorização dos papéis recomendados, também se beneficia da exposição ao dólar.',
        },
        {
          image: '/static/assinaturas/vacas-leiteiras-min.jpg',
          title: 'Vacas Leiteiras',
          author: 'Por Rodolfo Amstalden',
          description: 'Investir nessas ações é como se tornar sócio da companhia, recebendo uma fatia da distribuição dos lucros. Tudo isso por meio de estratégias sólidas e de baixo risco a longo prazo.',
        },
      ]
		}
  },
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return 4;
      }

      if (this.$vuetify.breakpoint.width >= 800) {
        return 3;
      }

      if (this.$vuetify.breakpoint.width >= 600) {
        return 2;
      }

      return 1;
    }
  },
  methods: {
    goToForm () {
      const form = document.getElementById('contact')
      form.scrollIntoView({ behavior: 'smooth' })
    },
  }
}
</script>

<style lang="scss">
.pass-series {
  background-color: var(--default-black);
  display: flex;
  justify-content: center;
  width: 100%;
}

.pass-series--wrapper {
  display: flex;
  justify-content: center;
  max-width: 1920px;
  width: 100%;
}

.pass-series--container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1256px;
  padding: 40px 0;
  width: 100%;

  @media only screen and (min-width: 600px) {
    align-items: center;
    display: flex;
    padding: 80px 0;
  }

  @media only screen and (min-width: 1024px) {
    padding: 80px 0;
  }
}

.pass-series--title {
  color: var(--white);
  font-family: var(--dm-sans-bold);
  font-size: 1.4rem;
  line-height: 26px;
  margin-bottom: 20px !important;
  text-align: center;

    @media only screen and (min-width: 600px) {
      font-size: 1.6989rem;
      line-height: 31px;
      margin-bottom: 40px !important;
      max-width: 704px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1.9416rem;
      line-height: 35px;
      max-width: 100%;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 2.7959rem;
      line-height: 50px;
    }
}

.serie-text {
  padding: 20px 20px 38px 20px;
}

.serie-content {
  background: #0C0E14 !important;
  max-width: 290px !important;

  .serie-titles {
    border-bottom: 1px solid #283241;
    max-width: 240px;
    margin-bottom: 26px !important;
  }

  .serie-title {
    font-family: var(--dm-sans-bold);
    font-size: 13.5px;
    line-height: 18px;
    text-align: center;
    color: var(--white);
    margin-bottom: 4px !important;
  }

  .serie-author {
    font-family: var(--dm-sans-bold);
    font-size: 13.5px;
    line-height: 18px;
    color: #B8C1C8;
    margin-bottom: 8px !important;
  }

  .serie-description {
    font-family: var(--dm-sans-regular);
    font-size: 12px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    color: #B8C1C8;
    max-width: 250px;
  }
}

.v-carousel__controls {
  display: none !important;
}

.serie-container {
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 600px) {
    justify-content: space-around;
  }
}

.serie-col {
  max-width: 290px;
  width: 100%;
}

.serie-content {
  img {
    width: 290px;
  }
}

.theme--dark.v-btn.v-btn--icon {
  background: #2D303D !important;
  color: #B8C1C8 !important;

  i {
    font-size: 20px !important;
  }
}

.v-window__next, .v-window__prev {
  margin: 0 !important;
  top: calc(50% - 50px) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Section/Section4.vue